<script lang="ts">
  import {
    applyReducer,
    getDocumentStyle,
    styleToString,
  } from "@shared/common/node/style";
  import type { IDocumentNode, PartialNode } from "@shared/common/node/type";
  import type { ICampaignSetting } from "@shared/common/types/campaign";
  import { getContext } from "svelte";
  import {
    getIsChildDocument,
    getStore,
    setDocumentNodeContext,
  } from "../../context";

  export let node: PartialNode<IDocumentNode>;
  export let wrapperType: "iframe" | "embedded";

  setDocumentNodeContext(node);
  const { embeddedInserterHorizontalAlign } = getStore();
  const isChildDocument = getIsChildDocument();

  let safeArea = false;
  let defaultSafeAreaColor = { r: "255", g: "255", b: "255" };

  const campaignSetting = getContext<ICampaignSetting>("campaignSetting");

  $: if (
    wrapperType === "iframe" &&
    node.safeArea?.value &&
    node.device === "MOBILE" &&
    node.position?.includes("BOTTOM")
  ) {
    safeArea = true;
  }
</script>

<div
  style={styleToString(
    applyReducer(
      getDocumentStyle(node, campaignSetting.language, {
        forceHorizontalAlign: !isChildDocument
          ? $embeddedInserterHorizontalAlign
          : undefined,
        defaultFont: campaignSetting.defaultFont,
      }),
      (style) => {
        if (wrapperType === "iframe" && node.width && node.width.unit === "%") {
          style.width = "100%";
        }
        return style;
      }
    )
  )}
>
  <slot />

  <!-- SafeArea 처리 (device: MOBILE / position: BOTTOM_~ / safeArea 설정) -->
  {#if safeArea}
    <div
      style={styleToString({
        width: "100%",
        height: "env(safe-area-inset-bottom)",
        backgroundColor: `rgba(${Object.values(
          node.safeArea?.color ?? defaultSafeAreaColor
        ).join(",")}, 1)`,
      })}
    />
  {/if}
</div>
